let treeChildren = (index, data, Vue) => {
  var arr = [];
  if (data) {
    for (let i = 0; i < 10; i++) {
      var obj = {};
      obj.title = `${i}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        const ballData = data[row.index].balls.split(',')
        var name = `ball${index + 1}`;
        if (row.row.ball_json[name].nums[i] == 0) {
          return <span class="red">{ballData[index]}</span>;
        } else if (Vue.divideList[i] > row.index) {
          return <span class="divide_lost_info lost_info">{row.row.ball_json[name].nums[i]}</span>;
        } else {
          return <span class="lost_info">{row.row.ball_json[name].nums[i]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
var lostTreeChildren = (index, data) => {
  var arr = [];
  if (data) {
    for (let i = 0; i < 10; i++) {
      var obj = {};
      obj.title = `${i}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name].nums[i];
        if (key != 'averageOmit') {
          return <span>{n[key] ? n[key] : 0}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let xingtaiChildren = data => {
  var arr = [];
  var shape = ['大', '小', '单', '双', '合', '质'];
  var str = ['big', 'small', 'single', 'double', 'com', 'prime'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        if (i < 2) {
          var divideList = data[0].ballObj.ballBigSmall[str[i]];
          var n = row.row.ballObj.ballBigSmall[str[i]];
          if (n == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
          // } else {
          //   return <span class="table_join">{row.row.ballObj.ballBigSmall[str[i]]}</span>;
          // }
        } else if (1 < i && i < 4) {
          var divideList = data[0].ballObj.ballSingleDouble[str[i]];
          var n = row.row.ballObj.ballSingleDouble[str[i]];
          if (row.row.ballObj.ballSingleDouble[str[i]] == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }

        } else if (i > 3) {
          var divideList = data[0].ballObj.ballPrimeCom[str[i]];
          var n = row.row.ballObj.ballPrimeCom[str[i]];
          if (row.row.ballObj.ballPrimeCom[str[i]] == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }

        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let luChildren = data => {
  var arr = [];
  var shape = ['0', '1', '2'];
  var str = ['0', '1', '2'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var divideList = data[0].ballObj.ballYuShu[str[i]];
        var n = row.row.ballObj.ballYuShu[str[i]];
        if (n == 0) {
          return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
        } else if (divideList > row.index) {
          return <span class="divide_lost_info lost_info">{n}</span>;
        } else {
          return <span class="lost_info">{n}</span>;
        }
        // } else {
        //   return <span class="table_join">{row.row.ballObj.ballYuShu[str[i]]}</span>;
        // }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let spjChildren = data => {
  var arr = [];
  var shape = ['升', '平', '降'];
  var str = ['sheng', 'ping', 'jiang'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var divideList = data[0].ballObj.ballSPJ[str[i]];
        var n = row.row.ballObj.ballSPJ[str[i]];
        if (n == 0) {
          return <span class={`table_join_${(i + 1) % 2}`}>{shape[i]}</span>;
        } else if (divideList > row.index) {
          return <span class="divide_lost_info lost_info">{n}</span>;
        } else {
          return <span class="lost_info">{n}</span>;
        }
        // } else {
        //   return <span class="table_join">{row.row.ballObj.ballSPJ[str[i]]}</span>;
        // }
      };
      arr.push(obj);
    }
    return arr;
  }
};
var lostXtChildren = (data, index) => {
  var arr = [];
  var shape = ['大', '小', '单', '双', '合', '质'];
  var str = ['big', 'small', 'single', 'double', 'com', 'prime'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name];
        if (i < 2) {
          return <span>{n.ballBigSmall[str[i]][key]}</span>;
        } else if (1 < i && i < 4) {
          return <span>{n.ballSingleDouble[str[i]][key]}</span>;
        } else if (i > 3) {
          return <span>{n.ballPrimeCom[str[i]][key]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

let lostLuChildren = (data, index) => {
  var arr = [];
  var shape = ['0', '1', '2'];
  var str = ['0', '1', '2'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name];
        return <span>{n.ballYuShu[str[i]][key] ? n.ballYuShu[str[i]][key] : 0}</span>;
      };
      arr.push(obj);
    }
    return arr;
  }
};

let lostSpjChildren = (data, index) => {
  var arr = [];
  var shape = ['升', '平', '降'];
  var str = ['sheng', 'ping', 'jiang'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name];
        return <span>{n.ballSPJ[str[i]][key] ? n.ballSPJ[str[i]][key] : 0}</span>;
      };
      arr.push(obj);
    }
    return arr;
  }
};
const ssc = (data, ballindex) => {
  var ball = ['一', '二', '三', '四', '五'];

  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 170
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 150,
        className: `table_issueId`,
        render: (h, { row }) => {
          let ball = row.balls.split(',')
          return (
            <div class="pk_balls">
              {ball.map((x, i) => {
                return (
                  // <span class={`pk_ball_${i}`} key={i}>
                  <span class={ballindex == i ? 'ball_red' : ''} key={i}>
                    {x}
                  </span>
                );
              })}
            </div>
          );
          // <span class="issue_result">{row.balls.split(',').join('')}</span>;
        }
        // render: (h, { row }) => <span class="issue_result">{row.balls.split(',').join('')}</span>
      },
      {
        // title: '第一球号码走势',
        title: `第${ball[ballindex]}球号码走势`,
        align: 'center',
        // width: 300,
        className: `table_issueId`,
        children: treeChildren(ballindex, data, Vue)
      },
      {
        title: '形态特征',
        align: 'center',
        // width: 300,
        className: `table_issueId`,
        children: xingtaiChildren(data)
      },
      {
        title: '012路',
        align: 'center',
        className: `table_issueId`,
        children: luChildren(data)
        // width: 150
      },
      {
        title: '升平降',
        align: 'center',
        className: `table_issueId`,
        children: spjChildren(data)
        // width: 150
      }
    ];
    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 320
      },
      {
        // title: '第一球号码走势',
        title: `第${ball[ballindex]}球号码走势`,
        align: 'center',
        // width: 300,
        className: `table_issueId`,
        children: lostTreeChildren(ballindex, data)
      },
      {
        title: '形态特征',
        align: 'center',
        // width: 300,
        className: `table_issueId`,
        children: lostXtChildren(data, ballindex)
      },
      {
        title: '012路',
        align: 'center',
        className: `table_issueId`,
        children: lostLuChildren(data, ballindex)
        // width: 150
      },
      {
        title: '升平降',
        align: 'center',
        className: `table_issueId`,
        children: lostSpjChildren(data, ballindex)
        // width: 150
      }
    ];
    return arr;
  };
  let describe =
    '<p>大小：5～9属大号，0～4属小号。</p>' +
    '<p>单双：1、3、5、7、9属单数，0、2、4、6、8属双数。</p>' +
    '<p>质合：1、2、3、5、7属质数，0、4、6、8、9属合数。' +
    '<p>遗漏期数：自上期开出到本期间隔的期数。</p>' +
    '<p>出现次数：统计周期内，某个号码的累计出现次数。</p>' +
    '<p>最大遗漏：是指统计周期内所有遗漏值的最大值。</p>' +
    '<p>最大连出：是指统计周期内所有连出值的最大值。</p>';
  return { list, lostList, describe };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Dingweizoushi/columns/ssc.js